import styled from "styled-components";
import { theme } from "@components/variables";

export const ValidationError = styled.div`
  padding-top: 5px;
  font-size: 10px;
  color: ${theme.red};
`;
